import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AssessmentProvider } from "./context/AssessmentContext";
import Landing from "./pages/Landing";
import Assessment from "./pages/Assessment";
import Review from "./pages/Review";
import FacilitatorDashboard from "./pages/FacilitatorDashboard";

function App() {
  return (
    <AssessmentProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/assessment" element={<Assessment />} />
            <Route path="/review" element={<Review />} />
            <Route path="/facilitator/:sessionId" element={<FacilitatorDashboard />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </div>
    </AssessmentProvider>
  );
}

export default App;
